import { getMostAlignedSdgs } from '@upright/common/model/output/scores/sdg-alignment/utils';
import { Valence } from '@upright/common/model/types';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useSdgLensContext } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/use-sdg-lens-context';
import { toSdgAligmentValence } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/utils';
import { SdgBoxWithBar } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/sdg-box-with-bar';

interface Props {
  valence: Valence;
}

export function SdgBoxesWithBarsForValence(props: Props) {
  const ctx = useSdgLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data.sdgAlignments;
  if (!data) {
    return <></>;
  }
  const sdgIds = getMostAlignedSdgs(data, toSdgAligmentValence(props.valence), false);
  const elems = sdgIds.map(sdgId => {
    return <SdgBoxWithBar key={sdgId} side={valenceToSide(props.valence)} sdgId={sdgId} />;
  });
  return <>{elems}</>;
}
